function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React, { useId } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { Container } from "../../atoms";
import { SectionHeader, ImageActionCard } from "../../molecules";
export default function ImageActionCardsSection(param) {
    var title = param.title, subtitle = param.subtitle, cards = param.cards, className = param.className;
    var id = useId();
    return /*#__PURE__*/ React.createElement(Container, {
        containerClassName: twMerge("max-w-xl", className)
    }, !!(title || subtitle) && /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title,
        subtitle: subtitle,
        className: "max-w-none mb-6"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6 grid-cols-1 grid-flow-row auto-rows-max md:grid-cols-2"
    }, cards.map(function(card) {
        return /*#__PURE__*/ React.createElement(ImageActionCard, _object_spread({
            key: "image-action-card-".concat(id, "-").concat(card.title)
        }, card));
    })));
}

//# sourceMappingURL=ImageActionCardsSection.js.map